import { Component } from '@angular/core';
import { PageBannerDTO } from '@signature-it/ngx-generic/models';
import { PageBannerService } from '@signature-it/ngx-generic/services';
import { Router } from '@angular/router';

declare let _: any;

@Component({
    selector: 'page-banner',
    templateUrl: './page-banner.html',
    styleUrls: ['./page-banner.scss'],
    standalone: false
})

export class PageBannerComponent {
    pageBannerContent: PageBannerDTO;
    constructor( public pageBannerSvc: PageBannerService,
                 protected router: Router) {
        this.initPageBanner();
    }

    initPageBanner() {
        this.pageBannerSvc.pageBanner$.subscribe(
            (data) => {
                if (data) {
                    this.pageBannerContent = data['dataPageBannner'];
                }
            }
        );
    }

}
